import React, { useEffect } from 'react'
import cx from 'classnames'
import { useDispatch } from 'react-redux'
import { styled } from '@mui/material/styles'
import MuiGrid from '@mui/material/Grid'
import url from 'libraries/front-end-core/core/url'
import connect from 'libraries/front-end-core/decorators/connect'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { DASHBOARD, CURRENT_AWARENESS } from 'constants/controllers'
import { requestGroup, requestHomePageArticles } from 'services/CurrentAwarenessService'
import ArticleContainer from 'redux/containers/pages/currentawarenessarticle/ArticleContainer'
import RecentStoriesContainer from 'redux/containers/pages/currentawarenessarticle/RecentStoriesContainer'
import { setHomepageArticles } from 'redux/actions'
import ArrowLink from 'components/redesign/ArrowLink'
import ResponseConsumer from 'components/shared/ResponseConsumer'

const Grid = styled(MuiGrid)({
  '&.MuiGrid-item': {
    paddingTop: '0px !important'
  }
})

export const BackToHomeLink = ({ containerClassName, className, aol }) => {
  const homeUrl = url(DASHBOARD, { aol })

  return (
    <div className={cx(containerClassName)}>
      <div className={cx('flex items-center', className)}>
        <ArrowLink backArrow text='Back to home' url={homeUrl} />
      </div>
    </div>
  )
}

const ArticleGrid = ({ group, flavour, aol, ...props }) => {
  if (!group) {
    return null
  }
  const article = group[0].groupSource.value[0]
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setHomepageArticles(props.homepageArticles))
  }, [props.homepageArticles, setHomepageArticles])

  return (
    <div className='article-grid pt9'>
      <div className='bg-page-background'>
        <div className='layout-width-constraint'>
          <BackToHomeLink flavour={flavour} containerClassName='relative mb9' className='absolute bottom6' aol={aol} />
          <Grid container direction='row' justifyContent='center' spacing={2}>
            <Grid item xs={12} sm={12} md={8}>
              <ArticleContainer {...{ ...props, ...article, flavour, aol }} id={props.id} />
              <div className='ba b--cadet-blue mt5 dn db-t' />
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <RecentStoriesContainer flavour={flavour} filterId={article.id} aol={aol} />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  )
}

const redirect = ({ aol, flavour, id }) => replaceUrl(url(CURRENT_AWARENESS, { aol, flavour, id }))

const ArticleGridWrapper = (props) => {
  const { group, aol } = props

  return (
    <ResponseConsumer
      response={group}
      content={() => {
        if (group[0].id === '/') { /* TODO: Legacy, should remove in November [UPDATE: can delete now ?] */
          redirect(props)
          return null
        }
        return <ArticleGrid {...props} publishDate={group[0].title} aol={aol} />
      }}
      notfoundComponent={() => {
        redirect(props)
        return null
      }}
    />
  )
}

export default connect(
  ({ id, aol }) => ({
    group: requestGroup({ id, aol }),
    homepageArticles: requestHomePageArticles(aol)
  })
)(ArticleGridWrapper)
